import React from 'react'
import styled from 'styled-components'
import { IconContext } from "react-icons";
import { FiMapPin, FiSend } from "react-icons/fi";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-left: 2rem;
`

const Location = styled.div`
  margin-top: 20px;
  ul {
    list-style: none outside none;
    li {
      display: inline-block;
      @media (min-width: 1024px) {
        display: list-item;
      }
      svg {
        height: 20px;
        @media (min-width: 1024px) {
          height: auto;
        }
      }
    }
  }
  @media (min-width: 1024px) {
    margin-top: 80px;
  }
`

const Email = styled.div`
  margin-top: auto;
  margin-bottom: 20px;
  @media (min-width: 1024px) {
    margin-bottom: 80px;
  }
`

const PinIcon = styled(FiMapPin)`
  display: inline-block;
  vertical-align: middle;
`

const H3 = styled.h3`
  text-transform: uppercase;
`

const H5 = styled.h5`
  display: inline-block;
  vertical-align: middle;
`

const SendIcon = styled(FiSend)`
  display: inline-block;
  vertical-align: middle;
`

class Contact extends React.Component {
  render() {
    return(
      <IconContext.Provider key="scroll" value={{ color: "white", className: "location-icon", size: "1.5em" }}>
        <Container>
          <Location>
            <H3 className="text-white font-mono mb-2 lg:mb-5 text-base lg:text-2xl">Main locations</H3>
            <ul>
              <li className="pr-2 lg:pr-0"><PinIcon/><H5 className="text-white font-mono pl-2 text-xs lg:text-base">London (UK)</H5></li>
              <li className="pr-2 lg:pr-0"><PinIcon/><H5 className="text-white font-mono pl-2 text-xs lg:text-base">Málaga (Spain)</H5></li>
              <li className="pr-2 lg:pr-0"><PinIcon/><H5 className="text-white font-mono pl-2 text-xs lg:text-base">Milano (Italy)</H5></li>
            </ul>
          </Location>

          <Email>
            <H3 className="text-white font-mono mb-2 lg:mb-5 text-base lg:text-2xl lg:pt-0">Email us</H3>
            <SendIcon/><a className="text-white font-mono pl-2" href="mailto:info@soulweb.it" title="Email us">info@soulweb.it</a>
          </Email>
        </Container>
      </IconContext.Provider>
    )
  }
}

export default Contact
